import SwipeableViews from 'react-swipeable-views';

import { bindKeyboard, virtualize } from 'react-swipeable-views-utils';

export const withBoundedKeyboard = bindKeyboard(SwipeableViews);
export const virtualized = virtualize(SwipeableViews);

// Ordering of HOCs is important.
// Please see https://react-swipeable-views.com/getting-started/usage/#composition-of-hocs
const VirtualizeSwipeableViews = bindKeyboard(virtualize(SwipeableViews));
export { VirtualizeSwipeableViews };
